import React, { useState } from "react";
import { Layout, Menu, Drawer, Grid } from "antd";
import {
  DashboardOutlined,
  UserOutlined,
  EyeOutlined,
  PlusOutlined,
  ShoppingCartOutlined,
  MenuOutlined,
  ProjectOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { useNavigate, Outlet, useParams } from "react-router-dom";
import AppHeader from "../Header";

const { Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const CompanyDashboardLayout = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const { companyId } = useParams();

  const menuItems = [
    {
      key: "1",
      icon: <DashboardOutlined />,
      label: "Dashboard",
      onClick: () => navigate(`/company/${companyId}`),
    },
    {
      key: "2",
      icon: <UserOutlined />,
      label: "Employees",
      children: [
        {
          key: "2-1",
          icon: <PlusOutlined />,
          label: "Add Employee",
          onClick: () => navigate(`/company/${companyId}/user/createuser`),
        },
        {
          key: "2-2",
          icon: <EyeOutlined />,
          label: "View Employees",
          onClick: () => navigate(`/company/${companyId}/user/viewUser`),
        },
      ],
    },
    {
      key: "3",
      icon: <ShoppingCartOutlined />,
      label: "Inventory",
      //   onClick: () => navigate(`/company/${companyId}/inventory`),
      children: [
        {
          key: "3-1",
          icon: <PlusOutlined />,
          label: "Create Inventory",
          onClick: () => navigate(`/company/${companyId}/inventory/create`),
        },
        {
          key: "3-2",
          icon: <EyeOutlined />,
          label: "View Inventory",
          onClick: () => navigate(`/company/${companyId}/inventory/view`),
        },
      ],
    },
    {
      key: "4",
      icon: <ShoppingCartOutlined />,
      label: "Order",
      //   onClick: () => navigate(`/company/${companyId}/inventory`),
      children: [
        {
          key: "4-1",
          icon: <PlusOutlined />,
          label: "Create Order",
          onClick: () => navigate(`/company/${companyId}/order/create`),
        },
        {
          key: "4-2",
          icon: <EyeOutlined />,
          label: "View Order",
          onClick: () => navigate(`/company/${companyId}/order/view`),
        },
      ],
    },
    {
      key: "5",
      icon: <ShoppingCartOutlined />,
      label: "Distribute Pay",
      onClick: () => navigate(`/company/${companyId}/distributePay`),
    },
    {
      key: "6",
      icon: <ProjectOutlined />,
      label: "Services",
      children: [
        {
          key: "6-1",
          icon: <PlusOutlined />,
          label: "Add service",
          onClick: () => navigate(`/company/${companyId}/service/create`),
        },
        {
          key: "6-2",
          icon: <EyeOutlined />,
          label: "View service",
          onClick: () => navigate(`/company/${companyId}/service/view`),
        },
      ],
    },
    {
      key: "8",
      icon: <ProjectOutlined />,
      label: "Reports",
      // onClick: () => navigate("/users"),
      children: [
        {
          key: "8-3",
          icon: <PlusOutlined />,
          label: "Expense report",
          onClick: () =>
            navigate(`/company/${companyId}/reports/expenseReport`),
        },
      ],
    },

    {
      key: "11",
      icon: <ProjectOutlined />,
      label: "Discount",
      onClick: () => navigate(`/company/${companyId}/discount`),
    },
    {
      key: "11-1",
      icon: <ProjectOutlined />,
      label: "Settings",
      onClick: () => navigate(`/company/${companyId}/settings`),
    },
    {
      key: "12",
      icon: <ProjectOutlined />,
      label: "Expense",
      onClick: () => navigate(`/company/${companyId}/expense`),
    },
    {
      key: "13",
      icon: <DashboardOutlined />,
      label: "Plans",
      onClick: () => navigate(`/company/${companyId}/plans`),
    },
    {
      key: "14",
      icon: <DashboardOutlined />,
      label: "Members",
      onClick: () => navigate(`/company/${companyId}/members`),
    },
    {
      key: "15",
      icon: <TeamOutlined />,
      label: "Users",
      onClick: () => navigate(`/company/${companyId}/users`),
    },
  ];

  const renderMenu = () => (
    <Menu theme="dark" mode="inline" items={menuItems} />
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {screens.md ? (
        <Sider collapsible>{renderMenu()}</Sider>
      ) : (
        <Drawer
          title="Menu"
          placement="left"
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ padding: 0 }}
        >
          {renderMenu()}
        </Drawer>
      )}
      <Layout>
        <AppHeader onMenuClick={() => setDrawerVisible(true)} />
        <Content style={{ margin: "16px" }}>
          <div
            style={{
              padding: 24,
              background: "#fff",
              minHeight: 360,
              borderRadius: 8,
            }}
          >
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default CompanyDashboardLayout;
